export default {"src":"/_next/static/media/Close.138179da.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};